export default __webpack_public_path__ + "static/media/rote_bomba_full.57b20bae.png";